import { render, staticRenderFns } from "./WhatsAvatar.vue?vue&type=template&id=29e2d9cd&scoped=true"
import script from "./WhatsAvatar.vue?vue&type=script&lang=js"
export * from "./WhatsAvatar.vue?vue&type=script&lang=js"
import style0 from "./WhatsAvatar.vue?vue&type=style&index=0&id=29e2d9cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e2d9cd",
  null
  
)

export default component.exports